import React, { useEffect } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { HelpCircle } from 'lucide-react';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    document.title = 'FAQ - Frequently Asked Questions | Fundora Global';
  }, []);

  const faqs = [
    { question: t('faq.questions.q1'), answer: t('faq.questions.a1') },
    { question: t('faq.questions.q2'), answer: t('faq.questions.a2') },
    { question: t('faq.questions.q3'), answer: t('faq.questions.a3') },
    { question: t('faq.questions.q4'), answer: t('faq.questions.a4') },
    { question: t('faq.questions.q5'), answer: t('faq.questions.a5') },
    { question: t('faq.questions.q6'), answer: t('faq.questions.a6') },
    { question: t('faq.questions.q7'), answer: t('faq.questions.a7') }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Header */}
      <section className="bg-gradient-to-br from-[#102131] to-[#1a3449] text-[#F7FDFF] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <HelpCircle size={64} className="text-[#CDA259] mx-auto mb-6" />
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            {t('faq.title')}
          </h1>
          <p className="text-xl text-[#F7FDFF]/80 max-w-2xl mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-[#F7FDFF] border border-[#CDA259]/20 rounded-lg px-6"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-[#102131] hover:text-[#CDA259] transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Still Have Questions */}
          <div className="mt-16 text-center p-8 bg-gradient-to-br from-[#102131] to-[#1a3449] rounded-xl">
            <h3 className="text-2xl font-bold text-[#F7FDFF] mb-4">
              {t('faq.stillHaveQuestions')}
            </h3>
            <p className="text-[#F7FDFF]/80 mb-6">
              {t('faq.stillHaveQuestionsDesc')}
            </p>
            <Link to="/contact">
              <Button className="bg-[#CDA259] text-[#102131] hover:bg-[#CDA259]/90 font-semibold">
                {t('faq.contactUs')}
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <Newsletter />
    </div>
  );
};

export default FAQ;
